
import { CDN_URL } from 'settings';

export function getCdnImage(image: string) {

  if (!image) {
    return '';
  }

  if (image.startsWith('https://')) {
    return image;
  }

  const numberImage = Number(image);

  if (isNaN(numberImage)) {
    return CDN_URL + image;
  }

  return `https://my.eduzz.com/file_upload/redirect/${image}/false`;
}

export function findGetParameter(parameterName: string) {
  const items = location.search.substr(1).split('&');

  for (let index = 0; index < items.length; index++) {
    const tmp = items[index].split('=');
    if (tmp[0] === parameterName) {
      return decodeURIComponent(tmp[1]);
    }
  }

  return '';
}

export function formatScripts(scripts: any) {
  if (!scripts) {
    return [];
  }

  return Object.keys(scripts)
    .filter(key => key.startsWith('has'))
    .filter(key => scripts[key] === '1')
    .map(key => {
      const realKey = key.replace(/^has/gi, '');
      return {
        type: realKey,
        value: scripts[realKey]
      };
    })
    .filter(data => !!data.value);
}


// WEBPACK FOOTER //
// ./src/functions.ts